!function() {
  class e extends HTMLElement {
    constructor() {
      super(), this.perPage = 6, this.currentPage = 0, this.appkey = this.dataset.appkey, 
      this.type = this.dataset.type || "album", this.slider = this.querySelector("[data-slider]"), 
      this.template = this.querySelector("template"), "product_ugc" === this.type ? this.url = `https://api.yotpo.com/v1/widget/${this.appkey}/albums/product/${this.dataset.productId}` : this.url = `https://api.yotpo.com/v1/widget/${this.appkey}/albums/by_name?album_name=${encodeURI(this.dataset.albumName)}`, 
      this.options = {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      };
    }
    connectedCallback() {
      const e = "product_ugc" === this.type ? this.dataset.productId : this.dataset.albumName;
      this.appkey && this.slider && e && (this.getPosts(), this.addEventListeners());
    }
    show() {
      this.closest(".max-h-0")?.classList.remove("max-h-0");
    }
    addEventListeners() {
      this.slider.addEventListener("scrollend", (() => {
        this.slider.children[this.slider.children.length - 3].getBoundingClientRect().x < window.innerWidth && this.getPosts();
      }), {
        passive: !0
      });
    }
    renderPosts(e) {
      this.total = e.pagination.total, this.pages = Math.ceil(this.total / e.pagination.per_page), 
      this.currentPage = e.pagination.page;
      const t = this.querySelector("template"), s = this.querySelector("[data-slider]");
      e.images?.forEach((e => {
        const a = t.content.cloneNode(!0);
        let i = [];
        if ("video" === e.media_type) {
          let t = document.createElement("video");
          t.controls = !0, t.muted = !0, t.autoplay = !0, t.playsInline = !0, t.poster = e.thumbnail_url, 
          t.classList.add("block", "w-full", "h-full", "object-cover"), [ "standard_resolution_url", "low_resolution_url" ].forEach(((s, a) => {
            let i = document.createElement("source");
            i.src = e[s] || e.standard_resolution_url, i.type = "video/mp4", i.classList.add(0 === a ? "tablet:hidden" : "desktop:hidden"), 
            t.appendChild(i);
          })), i.push(t);
        } else [ "medium_image_url", "low_resolution_image_url" ].forEach(((t, s) => {
          let a = document.createElement("img");
          a.src = e[t] || e.medium_image_url || e.standard_resolution_url || e.original_image_url || e.image_url, 
          a.classList.add("block", "w-full", "h-full", "object-cover"), a.classList.add(0 === s ? "tablet:hidden" : "desktop:hidden"), 
          i.push(a);
        }));
        i.forEach((t => {
          t.alt = e.post?.content, t.loading = "lazy", a.querySelector("[data-slide]").appendChild(t);
        })), s.appendChild(a);
      })), e.images?.length && this.show();
    }
    getPosts() {
      let e = this.currentPage + 1;
      if (this.pages && e > this.pages) return;
      let t = new URL(this.url);
      t.searchParams.set("per_page", this.perPage), t.searchParams.set("page", e), fetch(t).then((e => e.json())).then((e => this.renderPosts(e.response))).catch((e => console.error("error:" + e)));
    }
  }
  customElements.get("yotpo-feed") || customElements.define("yotpo-feed", e);
}();